import React, { createContext, useContext, useState } from 'react';

const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
  const [uploadComplete, setUploadComplete] = useState(false);

  const refreshHistory = () => {
    setUploadComplete(prev => !prev);
  };

  return (
    <UploadContext.Provider value={{ uploadComplete, refreshHistory }}>
      {children}
    </UploadContext.Provider>
  );
};

export const useUpload = () => {
  return useContext(UploadContext);
};